<script setup>
import fieldForm from './subComponents/fieldForm.vue'
import { useLocale } from 'vuetify'
const { t } = useLocale()

</script>

<template>
    <v-container>
        <v-form ref="form" :loading="loading">
        <v-row>
            <v-col cols="12" md="8" lg="6" class="mx-auto text-start">
               <h2 v-if="data.title" class="text-h4 text-md-h3 text-primary">{{ data.title }}</h2>
               <h3 v-if="data.sub_title" class="text-h6 text-md-h5 text-primary">{{ data.sub_title }}</h3>
            </v-col>
            <v-col cols="11" md="8" lg="6" class="mx-auto text-start">
               <v-row noGutters v-if="form.scope">
                <v-col cols="12" v-for="(field, index) in data.fields" :key="index+field.name">

                    <fieldForm :formVal="form" :field="field"></fieldForm>

                </v-col>

                <v-col cols="10" class="text-center mx-auto pt-5">
                    <v-btn :loading="loading" block @click="submit" class="rounded-pill mx-auto"  color="primary">{{data.button}}</v-btn>
                </v-col>
                <v-col cols="10" class="mx-auto my-4" v-if="message">

                    <v-alert 
                        :color="(success) ? 'success' : 'error'" 
                        :icon="(success) ? 'mdi-check' : 'mdi-close'" 
                        closable 
                        @click:close="resetDriveLeads">
                        <h2 v-if="success">{{ t(message+'.'+data.scope+'.title') }}</h2>
                        <p v-if="success">{{ t(message+'.'+data.scope+'.text') }}</p>
                        <span v-if="!success" >{{ message }}</span>
                    </v-alert>

                </v-col>
               </v-row>
            </v-col>
        </v-row>
        </v-form>
    </v-container>
</template>


<script>
import {mapGetters} from "vuex";
export default {
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            success: 'driveLeads/success',
            account: 'driveAuth/account',
            isAuthenticated: 'driveAuth/isAuthenticated',
            message: 'driveLeads/message',
            errors: 'driveLeads/errors',
            actions: 'driveLeads/actions',
            brands: 'carsDrive/brands',
            types: 'carsDrive/types',
            models: 'carsDrive/models',
        }),
    },
    data: () => ({
        form: {},
    }),
    mounted(){
        this.data.fields.forEach((element) => {
            if(element.name.startsWith('car_')){
                let el = element.name.split('.')
                if(!this.form.car){
                    this.form.car = {}
                }
                this.form.car[el[1]] = null
            }
            if(element.name.startsWith('rental_')){
                let el = element.name.split('.')
                if(!this.form.rental){
                    this.form.rental = {}
                }
                this.form.rental[el[1]] = null
            }
            this.form[element['name']] = null

            if(element['value']){
                this.form[element['name']] = element['value']
            }

        });


        if(this.isAuthenticated){
            if(this.account.email){
                this.checkSameKeys( this.data.fields, this.form, this.account)
            }
        }

        if(this.form.car){           
           if(this.brands.length == 0){
               this.$store.dispatch('carsDrive/getBrands', {online:true, availableOnly: true} )
           }
           if(this.types.length == 0){
               this.$store.dispatch('carsDrive/getTypes')
           }
           if(this.models.length == 0){
               this.$store.dispatch('carsDrive/getModels', {online:true, availableOnly: true})
           }

       }

        this.form.fromUrl = location.href
        this.form.scope = this.data.scope
        this.resetDriveLeads()
    },
    methods:{
        resetDriveLeads(){
            this.$store.dispatch('driveLeads/resetErrors')
        },
        checkSameKeys(fileds, form, account){
            fileds.forEach((element) => {
                if(account[element.name]){
                    form[element.name] = account[element.name]
                }
            });
        },
        async validate () {
            const { valid } = await this.$refs.form.validate()
            return valid;
        },
        reset () {
            this.$refs.form.reset()
        },
        resetValidation () {
            this.$refs.form.resetValidation()
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async submit(){
            this.resetValidation();

            let action = this.actions[this.data.scope]

            this.form.language = localStorage.getItem('locale');

                if(this.form.file){
                    this.form.attachments =  [{
                        "fileName": this.form.file[0].name,
                        "fileContent": await this.getBase64(this.form.file[0])
                    }];
                }


                if(this.form.car){
                    this.form.car = {
                        type: this.form.car_type.label,
                        brand: this.form.car_brand.name,
                        model: this.form.car_model.name,
                    }
                }
                if(this.form.rental){
                   if(this.form.rental_duration && this.form.rental_start){
                        this.form.rental = {
                            start: this.form.rental_start,
                            duration: this.form.rental_duration,
                        }
                   }
                }


                if( await this.validate() ){

                    this.$gtm.trackEvent({
                        'event': 'contact-form',
                        'data': this.form
                    })

                    await this.$store.dispatch('driveLeads/'+action,this.form).then(()=>{
                        this.resetValidation();
                    })
                }

        }
    }
}
</script>